module.exports = __webpack_public_path__ + "trust-logo-8dcdf08b65bbce519a0d.png";